import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import type { EditorState } from '@atlaskit/editor-prosemirror/state';

/** How many lines from the top of the doc still count for Summary auto-trigger (first line = 1). */
const MAX_LINES_FROM_DOC_START = 4;

/** How many lines from the end of the doc count for Conclusion auto-trigger. */
const MAX_LINES_FROM_DOC_END = 4;

/**
 * Which line of the document `pos` sits on, counting from 1.
 */
export function get1BasedLineIndexFromDocStart(doc: PMNode, pos: number): number {
	const maxPos = doc.content.size;
	const clamped = Math.max(1, Math.min(pos, maxPos));
	const slice = doc.textBetween(1, clamped, '\n', ' ');
	if (!slice) {
		return 1;
	}
	return slice.split('\n').length;
}

/** Whether the cursor is still in the first 4 lines. */
export function isCursorWithinDocStart(state: EditorState): boolean {
	return (
		get1BasedLineIndexFromDocStart(state.doc, state.selection.from) <= MAX_LINES_FROM_DOC_START
	);
}

/** Whether the cursor is in the last 4 lines of the doc. */
export function isCursorWithinDocEnd(state: EditorState): boolean {
	const { doc } = state;
	const cursorLine = get1BasedLineIndexFromDocStart(doc, state.selection.from);
	const totalLines = get1BasedLineIndexFromDocStart(doc, doc.content.size);
	return totalLines - cursorLine < MAX_LINES_FROM_DOC_END;
}
